/**
 * Shell — the channel:command BODY: the full-screen announcement stream + the
 * bottom command bar. The header is now PERSISTENT in Chrome (so it stays on every
 * route); Shell reads the channel + stream scope from the Chrome outlet context.
 *
 * The client is a thin renderer of world-owned announcements + a channel for
 * emitting commands — see feedback_blocks_are_world_announcements.
 */
import React from "react";

import { AnnouncementStream } from "./AnnouncementStream";
import { useChromeContext } from "./Chrome";

export const Shell: React.FC = () => {
  const { ch, scopePath, conversationId } = useChromeContext();
  // The Requests (tasks) tab is NOT a special body: the task queue is a normal
  // registered artifact whose conversation opens in this same stream (the rail
  // card resolves the queue artifact's logical conversation).
  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
      <AnnouncementStream ch={ch} scopePath={scopePath} conversationId={conversationId} />
    </div>
  );
};
